import { render, staticRenderFns } from "./AdjuntosTicketLinks.vue?vue&type=template&id=52b3d0fc&scoped=true"
import script from "./AdjuntosTicketLinks.vue?vue&type=script&lang=js"
export * from "./AdjuntosTicketLinks.vue?vue&type=script&lang=js"
import style0 from "./AdjuntosTicketLinks.vue?vue&type=style&index=0&id=52b3d0fc&prod&scoped=true&lang=css"
import style1 from "./AdjuntosTicketLinks.vue?vue&type=style&index=1&id=52b3d0fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3d0fc",
  null
  
)

export default component.exports